var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1803_384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 15,
    height: 15,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1803_384",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1803_384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1803_384",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADCElEQVR4nO2cvU4UYRSGj2ijhTfgX6zXOe8hmxASNESy50CQlkK9AbUSG7WR2GjtD0oPtlroFWiDdnoF2mkjBKIJWKwZAolZNQGc5Tvf53mSt995dnZm8767QxQEQRAEQRAEaWDW04DO1BkcnDwV70MfqKrxcwJbE1h3K2uAjoTshgHru18kb2cpRDeMQNd/F63rIbpx0db9U0J0/XGHjgjrW7Bt/E1U6my9tqVsr/f1twKBrqYWKTuOrmb5TYZZb6SXZ7s7u2HXySPt9tQRsM2BbSW1JOlX2JaF7fHw8PDhZKKFbT65COyb8PlEmmcHwPY9uQDsT8D6rT7mEI1iRf9flw5An1Iq6huEsD7avGE4kCF9iX4F9GHSm2EQBEEQBMH+U2LfAbYV8obAPhQnGvqevCGsr1KLkcajL8kbgD4p7oxmmyNvCOvt1GKk6bDdIm8Adjm5GDQcsUvk9Acu3ZLC3DlL3mi3OydTi5GG02rZCfLG9PT0QbD9SC1HGkp9LKOjo4fII2D7VI5o/UheEdib1IKksehr8gpYn6UXZM2EdZG8Auj95ILQTAC7R14R0WvlnNF2lbzCbFPlnNHjF8grVdWpUguShsKsZ8grQ0MTR1MLkoZSHwt5pogBgG2ZvFPCAACPhX+ZA4D6K/xLHADgsfAvcgBgh4V/kQOAOCz8e6nL8uSi8G/J4h9aJQwALY+Ff2kDADwX/iUNAPBc+Jc1AKjfwr+oAYAdF/4lDQDwXPj3UpfmqYXJHjPI41coF+rSPLUw2WukM0m5kPMAwJ4L/5IGgCHvhX8RAwBnUPiXMAAgh8K/jAFA/Rf+JQwAyKHw76Uuz7MTDbtJuVGX56nFyW5TdS5SbuQ4ACCHwr+EAaCVQ+Gf+wCAnAr/nAcA5FT45z0AaD6Ffy/CtpBeoO0sbAuUKzk9NhPQGcqVqpo47vlJu7ItmW0DGDtGOQPo3QwuG3cof2YHNp+N5/aSYQ+I6ACVArOOCesLgX1JLVdgn4XtOWDnU3sJgiAIgiAIgiAIgiCgDPkJ8WIN2wymDgIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogDeleteIcon);
export default __webpack_public_path__ + "static/media/logDeleteIcon.ff0f6fc639b23140a77c59a352f6edc7.svg";
export { ForwardRef as ReactComponent };